import type { IParticipant } from '@/app/queries/MeetingQuery/context';

export const cameraUidsOf = (participant: IParticipant) => [participant.user_id, ...participant.join_uids];

export const screenShareUidsOf = (participant: IParticipant) => [
  participant.screen_share_id,
  ...participant.screen_share_join_uids,
];

export const everyoneBut = (participants: IParticipant[], selfUid: number) =>
  participants.filter(participant => participant.user_id !== selfUid);

export const hostCameraUidsOf = (participants: IParticipant[]) =>
  new Set(participants.filter(participant => participant.is_host).flatMap(cameraUidsOf));

export const customerCameraUidsOf = (participants: IParticipant[]) =>
  new Set(participants.filter(participant => !participant.is_host).flatMap(cameraUidsOf));

export const remoteUidsWorthShowing = (participants: IParticipant[], selfUid: number) => {
  const otherCameras = everyoneBut(participants, selfUid).flatMap(cameraUidsOf);
  const everyScreenShare = participants.flatMap(screenShareUidsOf);

  return new Set([...otherCameras, ...everyScreenShare]);
};
